import React from 'react';

function TermsCondition() {
  return (
   <section className='termslooper'>
    <div className="container">
    <div className="p-8 max-w-4xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Terms and Conditions</h1>

      <p className="mb-4">
        Welcome to Carig photo letter! These terms and conditions outline the rules and regulations for the use of our website and services.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">1. Acceptance of Terms</h2>
      <p className="mb-4">
        By accessing this website, we assume you accept these terms and conditions. Do not continue to use the website if you do not agree to all of the terms stated here.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">2. Use License</h2>
      <p className="mb-4">
        Permission is granted to temporarily download one copy of the materials on our website for personal, non-commercial transitory viewing only.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">3. Limitations</h2>
      <p className="mb-4">
        In no event shall Carig photo letter or its suppliers be liable for any damages arising out of the use or inability to use the materials on our website.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Modifications</h2>
      <p className="mb-4">
        We may revise these terms of service at any time without notice. By using this website you are agreeing to be bound by the current version of these Terms and Conditions.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">5. Governing Law</h2>
      <p className="mb-4">
        These terms and conditions are governed by and construed in accordance with the laws of Carigphotoletter.com and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">6. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us at <a href="mailto:support@Carigphotoletter.com" className="text-blue-600 underline">support@Carigphotoletter.com</a>.
      </p>
    </div>
    </div>
   </section>
  );
}

export default TermsCondition;
